// ページトップ
import commonClass from "./commonClass";

export default class anchorScrollClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._$anchorScroll = $('.js-anchorScroll');
    this._scrollSpeed = 500;
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    cls._addMoveToAnchor();
  }

  // トップへのイベントを付与
  _addMoveToAnchor() {
    var cls = this;

    cls._$anchorScroll.on('click', function() {
      var anchor = $(this).data('anchor');
      var $anchortgt = $(anchor);
      if ($anchortgt.length) {
        var position = $anchortgt.offset().top;
        $('body, html').stop().animate({ scrollTop: position }, cls._scrollSpeed);
      }
    });
  }

}